/**
 * Canonical list of Framework Industry Types.
 *
 * These are the column headers in the "Menu Access (Framework)" admin tab
 * and are stored as the `subject` field in `menu_access_l3` for framework-gated rows.
 *
 * HOW TO ADD A NEW INDUSTRY TYPE:
 *   1. Add the string to this array.
 *   2. The Framework tab will automatically show the new column.
 *   3. Admins can then tick menu items under the new column via the admin UI —
 *      no further code changes needed.
 *
 * NOTE: These values are frontend-only. The backend stores them without validation.
 * They must also match the options shown in FrameworkModal.js (all frontend variants:
 * zav-frontend, zav-frontend-au, zav-frontend2) for consistency.
 *
 * IMPORTANT: This file intentionally does NOT contain a static registry of
 * which menu items are gated by which industry type. That mapping is now
 * admin-configured at runtime via the Menu Access (Framework) tab and stored
 * in menu_access_l3. The frameworkMappings cache in adminUserTypes.js reads
 * that data at sidebar load time.
 */

export const FRAMEWORK_INDUSTRY_TYPES = [
  'Cyber Security',
  'Data Protection',
  'Financial Services',
  'Artificial Intelligence',
  'Benchmark',
  'Health Services',
  'Business Governance',
  'Intellectual Property',
  'Non-Profit & Association Governance',
  'Quality',
  'Education',
  'Sustainability',
];
